import { Navigate, Outlet, useLocation } from 'react-router'
import { Loader2 } from 'lucide-react'
import { useAuth } from '@/auth/AuthContext'

/**
 * Guards nested routes: while the session is being restored it shows a spinner,
 * once resolved it renders the child routes for an authenticated user or
 * redirects to `/ops/login` (preserving the attempted location) otherwise.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-svh items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/ops/login" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}
